import { Link } from "react-router-dom"
import ImageBox from "@/components/image-box"
import { authStore } from "@/routes/login/auth-store"
import UserInfo from "./user-info"
import { langStore } from "@/stores/lang-store"
import { LOGO_SRC, navBundle } from "./nav-const"

const Sidebar = ({ navs }) => {
  const { user_id, user_name, role, scope_type } = authStore()
  const { lang } = langStore()

  const logoPath = role === "ADMIN" ? "/select" : scope_type === "group" ? "/select/apt" : null

  const LogoContent = (
    <>
      <ImageBox className="w-11 h-11" src={LOGO_SRC} />

      <h1 className="text-base font-bold mt-2.5 text-center whitespace-pre-wrap">
        {navBundle.title[lang]}
      </h1>
    </>
  )

  const containerClass =
    "flex flex-col justify-center items-center border-b border-b-white/30 pb-3 mb-2"

  return (
    <aside className="h-screen py-5 px-3 text-white sticky top-0 bg-nav-bg flex flex-col select-none">
      {logoPath ? (
        <Link to={logoPath} className={containerClass}>
          {LogoContent}
        </Link>
      ) : (
        <div className={containerClass}>{LogoContent}</div>
      )}

      <nav className="flex-1 overflow-y-auto no-scrollbar">{navs}</nav>

      <UserInfo userName={user_name} userId={user_id} />
    </aside>
  )
}

export default Sidebar
